import { fg } from '@atlassian/jira-feature-gating';
import type { AdvancedOptions, MappingState, ProjectData } from '../../common/types';
import {
	transformMappingStateToFieldMapping,
	transformMappingStateToIssueLinkMapping,
	transformToDateProperties,
	transformToUserEmailMappings,
} from '../../common/utils';
import type { StartImportPayload } from './types';

export const transformToStartImportPayload = (
	mappingState: MappingState,
	projectData: ProjectData,
	advancedOptions: AdvancedOptions,
	isIssueLinkingAllowed: Boolean = false,
): StartImportPayload => ({
	projectData,
	fileEncoding: advancedOptions.fileEncoding,
	delimiter: advancedOptions.delimiter,
	dateProperties: transformToDateProperties(advancedOptions),
	columns: transformMappingStateToFieldMapping(mappingState),
	...(isIssueLinkingAllowed && {
		issueLinkColumns: transformMappingStateToIssueLinkMapping(mappingState),
	}),
	...(mappingState.shouldImportUsers &&
		fg('enable-x2c-standardised-flow') && {
			userMapping: transformToUserEmailMappings(mappingState),
		}),
});
